import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
  const form = useRef();
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    message: '',
  });

  const [errors, setErrors] = useState({});

  // Function to validate email format
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // Function to validate the form fields
  const validateForm = () => {
    document.getElementById('Name').style.display = "block";
    document.getElementById('Email').style.display = "block";
    document.getElementById('message').style.display = "block";
    let formErrors = {};
    if (!formData.user_name.trim()) formErrors.user_name = '* Name is required';
    if (!formData.user_email.trim()) formErrors.user_email = '* Email is required';
    else if (!validateEmail(formData.user_email))
      formErrors.user_email = 'Invalid email format';
    if (!formData.message.trim()) formErrors.message = '* Message is required';

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNameError = ()=> {
    document.getElementById('Name').style.display = "none";
  }

  const handleEmailError = ()=> {
    document.getElementById('Email').style.display = "none";
  }

  const handleMessageError = ()=> {
    document.getElementById('message').style.display = "none";
  }

  // Function to send email and handle success/error alerts
  const sendEmail = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    emailjs
      .sendForm('Osama Ali', 'template_pcwusih', form.current, 'xVHKvSOsf2CnZvqqa')
      .then(
        () => {
          console.log('SUCCESS!');
          setFormData({ user_name: '', user_email: '', message: '' }); // Clear form inputs
          alert('Email sent successfully!'); // Success alert
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Failed to send email. Please try again.'); // Error alert
        }
      );
  };

  return (
    <div className="container">
      <div className="Contact-section">
        <h1> Get in Touch! </h1>
        <form className="Contact-form" ref={form} onSubmit={sendEmail}>
          <label>Name</label>
          <input type="text" name="user_name" placeholder="Enter Name" value={formData.user_name} 
            onChange={handleChange} onKeyUp={handleNameError} 
          />
          <span className="error" id="Name">{errors.user_name}</span>

          <label>Email</label>
          <input type="email" name="user_email" placeholder="Enter Email" value={formData.user_email} 
            onChange={handleChange} onKeyUp={handleEmailError}
          />
          <span className="error" id="Email">{errors.user_email}</span>

          <label>Message</label>
          <textarea name="message" placeholder="Type message" onKeyUp={handleMessageError} value={formData.message}
            onChange={handleChange}
          />
          <span className="error" id="message">{errors.message}</span>
          <button type="submit" onClick={validateForm}>Send</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
